import URLBuilder from 'url-builder';
import $ from 'jquery';

export default class JsonpApi {
  constructor(apiKey, authToken, gwiHost) {
    this.apiKey = apiKey;
    this.authToken = authToken;
    this.gwiHost = gwiHost;
  }

  getUserAuthToken() {
    const path = '/api/v3/session/auth_token';

    return this.get(path);
  }

  get(path) {
    const params = {
      api_key: this.apiKey,
      gwi_asset: true,
    };

    const url = URLBuilder.buildUrl(this.gwiHost, path, params);

    return $.ajax({
      url,
      type: 'GET',
      dataType: 'jsonp',
    });
  }
}



// WEBPACK FOOTER //
// ./src/shared/helpers/jsonp-api.js